(function () {
  if (window.__ga4_click_tracking_loaded) return;
  window.__ga4_click_tracking_loaded = true;

  // --- GA4 safety stub (works with Shopify GA installs) ---
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== "function") {
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
  }

  function cleanText(str) {
    return (str || "").replace(/\s+/g, " ").trim().toLowerCase();
  }

  function containsText(haystack, needle) {
    return haystack && haystack.indexOf(needle) !== -1;
  }

  function getClickableEl(target) {
    if (!target) return null;
    return target.closest
      ? target.closest("a, button, input[type='submit'], [role='button']")
      : target;
  }

  function pagePath() {
    return window.location.pathname || "/";
  }

  function sendGA4Event(eventName, params) {
    params = params || {};
    if (!params.page_path) params.page_path = pagePath();
    try {
      window.gtag("event", eventName, params);
    } catch (e) {}
  }

  // ---------- Click tracking ----------
  document.addEventListener(
    "click",
    function (e) {
      var el = getClickableEl(e.target);
      if (!el) return;

      var tag = (el.tagName || "").toLowerCase();
      var text = cleanText(el.innerText || el.value || "");
      var href =
        el.getAttribute && el.getAttribute("href")
          ? el.getAttribute("href")
          : "";

      // Email clicks (NO PII)
      if (tag === "a" && href && href.toLowerCase().indexOf("mailto:") === 0) {
        sendGA4Event("email_click", {
          contact_method: "email",
          page_path: pagePath()
        });
        return;
      }

      // Book a meeting CTA
      if (containsText(text, "book a meeting")) {
        sendGA4Event("book_a_meeting_click", {
          button_text: "Book a meeting",
          link_url: href || "",
          page_path: pagePath()
        });
        return;
      }

      // Get started CTA
      if (containsText(text, "get started")) {
        sendGA4Event("get_started_click", {
          button_text: "Get started",
          link_url: href || "",
          page_path: pagePath()
        });
        return;
      }

      // Speak to a gift expert CTA
      if (containsText(text, "speak to a gift expert")) {
        sendGA4Event("speak_to_gift_expert_click", {
          button_text: "Speak to a gift expert",
          link_url: href || "",
          page_path: pagePath()
        });
        return;
      }
    },
    true
  );

  // ---------- Form submit tracking ----------
  document.addEventListener(
    "submit",
    function (e) {
      var form = e.target;
      if (!form) return;

      var action = ((form.getAttribute && form.getAttribute("action")) || "").toLowerCase();
      var id = cleanText((form.getAttribute && form.getAttribute("id")) || "");
      var name = cleanText((form.getAttribute && form.getAttribute("name")) || "");
      var formText = cleanText(form.innerText || "");

      function contains(h, n) {
        return h && h.indexOf(n) !== -1;
      }

      // Quote request form
      if (
        contains(action, "quote") ||
        contains(id, "quote") ||
        contains(name, "quote") ||
        contains(formText, "quote")
      ) {
        sendGA4Event("quote_request_submit", {
          form_name: "quote_request",
          page_path: pagePath()
        });
        return;
      }

      // Contact form
      if (
        contains(action, "contact") ||
        contains(id, "contact") ||
        contains(name, "contact") ||
        contains(formText, "contact")
      ) {
        sendGA4Event("contact_form_submit", {
          form_name: "contact",
          page_path: pagePath()
        });
        return;
      }
    },
    true
  );

  // ---------- Enquiry completion (Zoho thank-you page) ----------
  // Fires once when a visitor lands on the thank-you page they are
  // redirected to after a successful Zoho form submission.
  function fireEnquiryIfThankYou() {
    var p = pagePath().replace(/\/+$/, "").toLowerCase();
    if (p === "/pages/thank-you") {
      sendGA4Event("enquiry_submit", {
        form_name: "speak_to_gift_expert",
        page_path: pagePath()
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fireEnquiryIfThankYou);
  } else {
    fireEnquiryIfThankYou();
  }
})();